/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_2_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit any active cell edit with Enter. Then choose File → Save As in the editor.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 Enter 确认正在编辑的单元格，再在编辑器中选择 File → Save As。`)
};

/**
* | output |
* | --- |
* | "Commit any active cell edit with Enter. Then choose File → Save As in the editor." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_steps_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_steps_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_steps_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_steps_0 as "gc.search_guides.gridcraft_online.sections.2.steps.0" }